import { AnyAction } from 'redux';
import {
  FetchReleaseNotesRoutine,
  CreateReleaseNoteRoutine,
  UpdateReleaseNoteRoutine,
  PublishReleaseNoteRoutine,
  DeleteReleaseNoteRoutine,
} from '../redux-routines';
import { IReleaseNote } from '../interfaces';
import { SELECT_RELEASE_NOTE } from '../constants';

export interface IReleaseNotesState {
  isFetching: boolean;
  data: IReleaseNote[];
  isCreating: boolean;
  isUpdating: boolean;
  isPublishing: boolean;
  isDeleting: boolean;
  selectedId: string | null;
}

const initialState: IReleaseNotesState = {
  isFetching: false,
  data: [],
  isCreating: false,
  isUpdating: false,
  isPublishing: false,
  isDeleting: false,
  selectedId: null,
};

export const releaseNotesReducer = (
  state: IReleaseNotesState = initialState,
  action: AnyAction
): IReleaseNotesState => {
  switch (action.type) {
    case SELECT_RELEASE_NOTE:
      return {
        ...state,
        selectedId: action.payload,
      };

    case FetchReleaseNotesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case FetchReleaseNotesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };

    case FetchReleaseNotesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
      };

    case CreateReleaseNoteRoutine.REQUEST:
      return {
        ...state,
        isCreating: true,
      };

    case CreateReleaseNoteRoutine.SUCCESS: {
      const newRelease = action.payload;

      // Check if draft already exists in list
      const existingIndex = state.data.findIndex(note => note.id === newRelease.id);

      let updatedData: IReleaseNote[];
      if (existingIndex >= 0) {
        updatedData = state.data.map(note => note.id === newRelease.id ? newRelease : note);
      } else {
        updatedData = [newRelease, ...state.data];
      }

      return {
        ...state,
        isCreating: false,
        data: updatedData,
      };
    }

    case CreateReleaseNoteRoutine.FAILURE:
      return {
        ...state,
        isCreating: false,
      };

    case UpdateReleaseNoteRoutine.REQUEST:
      return {
        ...state,
        isUpdating: true,
      };

    case UpdateReleaseNoteRoutine.SUCCESS:
      return {
        ...state,
        isUpdating: false,
        data: state.data.map(note => note.id === action.payload.id ? action.payload : note),
      };

    case UpdateReleaseNoteRoutine.FAILURE:
      return {
        ...state,
        isUpdating: false,
      };

    case PublishReleaseNoteRoutine.REQUEST:
      return {
        ...state,
        isPublishing: true
      };

    case PublishReleaseNoteRoutine.SUCCESS:
      return {
        ...state,
        isPublishing: false,
        data: state.data.map(note => note.id === action.payload.id ? action.payload : note),
      };

    case PublishReleaseNoteRoutine.FAILURE:
      return {
        ...state,
        isPublishing: false,
      };

    case DeleteReleaseNoteRoutine.REQUEST:
      return {
        ...state,
        isDeleting: true
      };

    case DeleteReleaseNoteRoutine.SUCCESS: {
      const deletedId = action.payload;
      return {
        ...state,
        isDeleting: false,
        data: state.data.filter(note => note.id !== deletedId),
      };
    }

    case DeleteReleaseNoteRoutine.FAILURE:
      return {
        ...state,
        isDeleting: false,
      };

    default:
      return state;
  }
};